import { injectGlobal } from "styled-components";
import reset from "styled-reset";
import { colors, fonts, media } from "./constants";
import * as webfonts from "../fonts";

injectGlobal`
  ${reset}

  @font-face {
    font-family: 'nau-web-title';
    font-style: normal;
    font-weight: bold;
    src: local('nau-web-title'), url('${webfonts.NauWeb}') format('woff2');
  }

  @font-face {
    font-family: 'nau-web-tall';
    src: local('nau-web-tall'), url('${webfonts.NauTall}') format('woff2');
    font-weight: 200;
  }

  @font-face {
    font-family: stack-mono;
    font-style: normal;
    font-weight: 300;
    src: local(".SFMono-Regular"), local(".Consolas"), local(".Liberation Mono"), local("Menlo"), local("Courier"), local("monospace");
  }

  @font-face {
    font-family: stack;
    font-style: normal;
    font-weight: 300;
    src: local(".SFNSText-Light"), local(".HelveticaNeueDeskInterface-Light"), local(".LucidaGrandeUI"), local("Ubuntu Light"), local("Segoe UI Light"), local("Roboto-Light"), local("DroidSans"), local("Tahoma");
  }

  html, body {
    height: 100%;
    font-size: 16px;
    ${media.xl`
      font-size: 14px;
    `}
  }

  body {
    background: ${colors.blue900};
    color: #fff;
    font-family: ${fonts.mono};
    backface-visibility: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${fonts.title};
    font-weight: bold;
    line-height: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: color ease-in .2s;

    &:hover {
      color: #fff;
    }
  }

  * {
    box-sizing: border-box;
    line-height: 1.4em;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-kerning: auto;
  }

  ::selection {
    color: ${colors.red500};
    background: transparent;
  }

  .custom-player-btn {
    color: white !important;
    padding: 0 0.5rem 0.2rem 0.5rem !important;
    font-size: .8rem !important;
  }
  .timer-wrap {
    display: flex;
    flex-direction: row;
  }

  .events {
    margin-top: 3rem;
    h2 {
      font-size: 1.2rem;
      margin-bottom:1.2rem;
    }
    h3 {
      font-size: 1rem;
      margin-bottom:1.2rem;
    }
    p {
      font-size: 0.9rem;
      color: #e3e3e3;
    }
    .past {
      opacity: 0.7;
      margin-top: 3rem;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/style/global.js